var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-resource',{attrs:{"lazy":_vm.lazy,"full-u-r-l":true,"src":_vm.srcString,"srcset":_vm.srcSet,"sizes":_vm.sizesString,"alt":_vm.alt,"width":_vm.width,"height":_vm.height,"ratio":_vm.ratio},on:{"error":_vm.setFallback}})
}
var staticRenderFns = []

export { render, staticRenderFns }